<template>
  <div class="container" v-if="showPage">
    <div class="logoBox">
      <Header :showLogo="true" :info="userInfo" />
    </div>
    <div class="payBox">
      <div class="content" v-if="userInfo.userId">
        <img class="printingImg" :src="require('img/pay/alipay_print.png')" />
        <p class="printingText">正在打印中</p>
        <p class="des">
          请到 <span class="equipmentName">{{ equipmentName }}</span> 前领取文件
        </p>
      </div>
      <div class="content" v-else>
        <img
          class="nocontentImg"
          :src="require('img/pay/alipay_nocontent.png')"
        />
        <p class="printingText">暂无文件打印</p>
      </div>
    </div>
    <div class="footer">
      版权信息 闽ICP备13015634号-7 ©2024 Foxit Software Incorporated. All rights
      reserved.
    </div>
  </div>
</template>

<script>
import { getUserInfo } from "api/api.js";
import Header from "./Header.vue";
import { APP_KEY } from "@/const/const";

export default {
  data() {
    return {
      equipmentName: null,
      userInfo: {},
      showPage: false
    };
  },
  components: {
    Header
  },
  mounted() {
    const { name, token } = this.$route.query;
    this.equipmentName = name
      ? decodeURIComponent(decodeURIComponent(name))
      : "打印机";
    if (token) {
      getUserInfo(token ? { token } : {}, {
        noErrorHandler: true,
        noAuth: true,
        noToken: true
      })
        .then(res => {
          if (res.code === 0) {
            const { data: userInfo } = res;
            this.userInfo = userInfo;
          }
          this.showPage = true;
        })
        .catch(() => {});
    }
    if (window.cloudCookies.accessToken || window.readerCookies.accessToken) {
      getUserInfo(
        {},
        {
          noErrorHandler: true,
          noAuth: true,
          noToken: true,
          headers: {
            Authorization: `Bearer ${window.cloudCookies.accessToken ||
              window.readerCookies.accessToken}`,
            appKey: APP_KEY
          }
        }
      )
        .then(res => {
          if (res.code === 0) {
            const { data: userInfo } = res;
            this.userInfo = userInfo;
          }
          this.showPage = true;
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  background-color: white;
  min-height: 860px;
  height: 100%;
  position: relative;
}
.logoBox {
  padding-top: 29px;
  height: 90px;
  width: 100%;
  position: relative;
  padding-right: 30px;
}

.payBox {
  width: 100%;
  min-height: 400px;
  min-width: 1000px;
  width: 100%;
  height: calc(100% - 100px);
  .content {
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    display: flex;
    height: calc(100% - 100px);
    .printingImg {
      width: 243px;
      height: 221px;
      margin-bottom: 42px;
    }
    .nocontentImg {
      width: 253px;
      height: 230px;
      margin-bottom: 42px;
    }
    .printingText {
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
      margin-bottom: 20px;
    }
    .des {
      font-size: 20px;
      font-weight: 400;
      color: #999999;
      line-height: 28px;
      .equipmentName {
        color: #ff9900;
      }
    }
  }
}

.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  min-width: 1000px;
  height: 80px;
  background-color: #47485b;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #c4c4cb;
}
</style>
